// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('personal-partials/header');
// require('personal-partials/viewport');
require('personal-partials/spmenu');
require('personal-partials/carousel_scroll');
require('personal-partials/plan_popup');
require('personal-partials/voice_popup');
require('personal-partials/bottom-cta');
